import React from 'react';
import { Box, Flex, Icon, Text, Link } from '@chakra-ui/react';
import { FaTwitter, FaTelegram, FaInstagram } from 'react-icons/fa';

const Footer = () => {
  return (
    <Box bg="#222222" color="red" py="5" px="10">
      <Flex justifyContent="center" mb="0" spacing="4">
        <Link href="https://x.com/SaintSeiyaSei" isExternal mx="2">
          <Icon as={FaTwitter} w={6} h={6} />
        </Link>
        <Link href="https://t.me/saintseiyasei" isExternal mx="2">
          <Icon as={FaTelegram} w={6} h={6} />
        </Link>
      </Flex>
    </Box>
  );
};

export default Footer;
